

import Page from "../component/Page";
import { Box, Button, ButtonGroup, Container, Typography } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import { useState } from "react";

const dataset_years = { "Hail": [1955, 2025], "Thunderstorm_Wind": [1955, 2025], "Tornado": [1880, 2025] };

export default function SevereWeatherClimate() {
    const [event, setEvent] = useState("Hail");

    return <Page>
        <Container sx={{ py: 5 }}>
            <NextBreadcrumbs></NextBreadcrumbs>
            <Box sx={{ display: "flex", justifyContent: "space-between", pt: 5, flex: 1 }}>
                <Typography variant="h4" gutterBottom>
                    {event.replace("_", " ")} Data <span style={{ fontSize: 'inherit' }}>({dataset_years[event][0]} - {dataset_years[event][1]})</span>
                </Typography>
                <ButtonGroup sx={{ alignSelf: "center" }}>
                    <Button variant="contained" disabled={event === "Hail"} onClick={() => { setEvent("Hail") }}>Hail</Button>
                    <Button variant="contained" disabled={event === "Thunderstorm_Wind"} onClick={() => { setEvent("Thunderstorm_Wind") }}>ThunderStorm Wind</Button>
                    <Button variant="contained" disabled={event === "Tornado"} onClick={() => { setEvent("Tornado") }}>Tornado</Button>
                </ButtonGroup>
            </Box>
            <Typography variant="body2" gutterBottom sx={{ maxWidth: { md: "55%" } }}>
                This material is, in part, based upon work supported by the National Science Foundation under Cooperative Agreement No. 2344533 and the Commonwealth of Kentucky. Any opinions, findings, and conclusions or recommendations expressed in this material are those of the authors and do not necessarily reflect the views of the National Science Foundation.
            </Typography>
            {event === "Tornado" ? <Typography variant="body1" gutterBottom>
                External Contributors: Tom Reaugh (NWS), WKU Student Kristen Ramey
            </Typography> : <Box sx={{ py: 1.5 }}></Box>}

            <iframe
                src={`https://sw.kymeso.net/embed/table/${event}`}
                style={{ "width": "100%", minHeight: 800, maxHeight: 1200, border: 0, }}
            ></iframe>

        </Container>
    </Page>

}